<div class="ss-search" [class.ss-search-expanded]="expanded">
  <button
    aria-label="Search SureSIM"
    [attr.aria-expanded]="expanded"
    class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
    [ngbTooltip]="showTooltips && !expanded ? 'Search SureSIM' : null"
    placement="bottom"
    tooltipClass="custom-tooltip-success"
    type="button"
    (click)="toggleExpanded()"
  >
    <i class="bi bi-search fs-20"></i>
  </button>

  <div class="ss-search-box">
    <input
      #searchInput
      aria-label="Search SureSIM"
      [attr.tabindex]="expanded ? 0 : -1"
      autocomplete="off"
      class="form-control ss-search-input"
      [(ngModel)]="searchText"
      placeholder="Search SureSIM"
      type="text"
      (focus)="onInputFocus()"
      (keydown)="onInputKeyDown($event)"
    >
    <div class="ss-search-box-tools">
      @if (searchText.trim()) {
        <button type="button" class="btn btn-sm ss-search-go" [disabled]="isSearching" (click)="onSearchClick()" aria-label="Search">Search</button>
      }
      @if (isSearching) {
        <span class="spinner-border spinner-border-sm text-primary"></span>
      } @else if (searchText) {
        <button type="button" class="btn btn-link p-0 lh-1 text-muted" (click)="clearSearch()" aria-label="Clear search">
          <i class="bi bi-x-circle-fill"></i>
        </button>
      }
    </div>
  </div>

  @if (showResults) {
    <div class="ss-search-results shadow-lg">
      @if (hint) {
        <div class="ss-search-state text-muted"><i class="bi bi-info-circle me-2"></i>{{ hint }}</div>
      } @else if (isSearching) {
        <div class="ss-search-state text-muted">Searching SureSIM for '<strong>{{ lastSearchedTerm }}</strong>'...</div>
      } @else if (totalRows===0) {
        <div class="ss-search-state text-muted">
          <i class="bi bi-search me-2"></i>Nothing found for '<strong>{{ lastSearchedTerm }}</strong>'.
          <div class="fs-12 mt-1">Try part of a name, an email, an ICCID, a company or a ticket number.</div>
        </div>
      } @else {
        <div class="ss-search-header">
          <div class="fs-12 text-muted">
            {{ totalRows }} result{{ totalRows===1 ? '' : 's' }} for '<strong class="text-body">{{ lastSearchedTerm }}</strong>'
          </div>
          @if (kindChips.length > 1) {
            <div class="ss-search-chips">
              <button type="button" class="btn btn-sm ss-search-chip" [class.active]="selectedKind==='all'" (click)="selectKind('all')">All</button>
              @for (chip of kindChips; track chip.kind) {
                <button type="button" class="btn btn-sm ss-search-chip" [class.active]="selectedKind===chip.kind" (click)="selectKind(chip.kind)">
                  {{ chip.label }} <span class="ss-search-chip-count">{{ chip.count }}</span>
                </button>
              }
            </div>
          }
        </div>

        <div class="ss-search-list">
          @for (group of visibleGroups; track group.kind) {
            <div class="ss-search-group-title">{{ group.label }}</div>
            @for (row of group.rows; track row.key) {
              <div class="ss-search-row" [class.active]="row.key===activeKey" (click)="executeAction(row.actions[0])" (mouseenter)="setActive(row)">
                <div class="avatar-xs flex-shrink-0">
                  <span class="avatar-title rounded fs-16" [ngClass]="kindColour(row.kind)">
                    <i [ngClass]="kindIcon(row.kind)"></i>
                  </span>
                </div>
                <div class="ss-search-row-body">
                  <div class="ss-search-row-title text-truncate" [title]="row.title">{{ row.title }}</div>
                  @if (row.meta) {
                    <div class="ss-search-row-meta text-muted text-truncate" [title]="row.meta">{{ row.meta }}</div>
                  }
                </div>
                <div class="ss-search-row-actions">
                  @for (action of row.actions; track $index) {
                    <button type="button" class="btn btn-sm btn-soft-primary ss-search-action" [title]="actionTitle(action)" (click)="executeAction(action, $event)">
                      <i class="me-1" [ngClass]="actionIcon(action)"></i>{{ actionShortLabel(action) }}
                    </button>
                  }
                </div>
              </div>
            }
          }
        </div>

        <div class="ss-search-footer text-muted">
          @if (truncated) {
            <div class="text-warning mb-1"><i class="bi bi-exclamation-triangle me-1"></i>Some results were limited. Refine your search to see more.</div>
          }
          <span><kbd>↑</kbd> <kbd>↓</kbd> move</span>
          <span><kbd>Enter</kbd> open</span>
          <span><kbd>Esc</kbd> close</span>
        </div>
      }
    </div>
  }
</div>
